import React, { Fragment } from "react";
import PanelHeader from "../PanelHeader";
import ThemeColorPickers from "../ThemeColorPickers";
import ThemeFontPicker from "../ThemeFontPicker";
import Tabs from "components/Tabs";
import { WHITE_TAB_STYLES } from "components/Tabs";
import OverscrollContent from "components/OverscrollContent";

const PageTheme = () => {
  const tabProps = {
    minWidth: false,
    equalWidth: false,
    pathPrefix: "",
    customStyles: WHITE_TAB_STYLES,
    customClasses: {
      tabs: {
        list:
          "list ma0 ph0 nowrap center overflow-x-auto absolute top-0 left-0 right-0 bh--inset"
      }
    },
    tabs: [
      {
        name: "Font",
        id: "font",
        node: <ThemeFontPicker />
      },
      {
        name: "Color",
        id: "color",
        node: <ThemeColorPickers />
      }
    ]
  };

  return (
    <Fragment>
      <PanelHeader title="Customize your theme" />
      <OverscrollContent>
        <div className="pt3 bg-white bh--inset">
          <Tabs {...tabProps} />
        </div>
      </OverscrollContent>
    </Fragment>
  );
};

export default PageTheme;
